interface Props { status?: string; statusFormatted?: string; className?: string; }

const COLORS: Record<string, string> = {
    NOT_SENT: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
    SENDING: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
    PENDING: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
    ACTIVE: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
    REJECTED: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
    FAILED_RETRYABLE: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300',
    FAILED_PERMANENT: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
};

const PismoStatusBadge = ({ status, statusFormatted, className = '' }: Props) => {
    if (!status) return <span className="text-gray-400">—</span>;
    const color = COLORS[status] || COLORS.NOT_SENT;
    return <span className={`inline-block whitespace-nowrap px-2 py-0.5 rounded text-[10px] font-medium ${color} ${className}`}>{statusFormatted || status}</span>;
};

export default PismoStatusBadge;
